import { useState } from "react";
import { SquaresFour, DownloadSimple, ListChecks, YoutubeLogo, CaretDown, Key } from "@phosphor-icons/react";

export const ADMIN_TABS = [
  { key: "dashboard", label: "Dashboard", icon: SquaresFour, title: "Dashboard", sub: "Affiliate revenue and referral traffic at a glance." },
  { key: "ingestion", label: "Ingestion Engine", icon: DownloadSimple, title: "Ingestion Engine", sub: "Pull films, music, kids content and discovery titles into the vault." },
  { key: "queue", label: "Queue & Audits", icon: ListChecks, title: "Queue & Audits", sub: "Review unmatched titles, audit auto-tagging and run catalog-wide syncs." },
  { key: "channels", label: "Channel Management", icon: YoutubeLogo, title: "Channel Management", sub: "Monitor channel health and add YouTube channels." },
];

// Left rail on desktop, horizontal tab strip on mobile.
export const AdminSidebar = ({ tab, setTab, token, saveToken }) => (
  <aside data-testid="admin-sidebar" className="border-b border-white/10 bg-[#070707] lg:sticky lg:top-[57px] lg:h-[calc(100vh-57px)] lg:w-64 lg:shrink-0 lg:border-b-0 lg:border-r">
    <nav className="flex gap-1 overflow-x-auto px-3 py-3 lg:flex-col lg:px-4 lg:py-8">
      <p className="hidden px-3 pb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-white/30 lg:block">Admin Portal</p>
      {ADMIN_TABS.map(({ key, label, icon: Icon }) => {
        const on = tab === key;
        return (
          <button
            key={key}
            type="button"
            data-testid={`admin-tab-${key}`}
            aria-current={on ? "page" : undefined}
            ref={(el) => on && el?.scrollIntoView?.({ inline: "nearest", block: "nearest" })}
            onClick={() => setTab(key)}
            className={`flex shrink-0 items-center gap-3 whitespace-nowrap border-l-2 px-3 py-2.5 text-left font-mono text-[11px] uppercase tracking-[0.14em] transition-colors duration-200 ${
              on ? "border-amber bg-amber/10 text-amber" : "border-transparent text-white/55 hover:bg-white/[0.04] hover:text-white"
            }`}
          >
            <Icon size={18} weight={on ? "fill" : "duotone"} /> {label}
          </button>
        );
      })}
    </nav>
    <div className="px-4 pb-4 lg:absolute lg:bottom-0 lg:w-64 lg:px-7 lg:pb-6">
      <label className="mb-2 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
        <Key size={14} weight="duotone" className="text-amber" /> Admin Token
      </label>
      <input
        data-testid="admin-token-input"
        type="password"
        value={token}
        onChange={(e) => saveToken(e.target.value)}
        placeholder="X-Admin-Token"
        className="w-full border border-white/10 bg-[#111] px-3 py-2 font-mono text-xs text-white placeholder-white/30 focus:border-amber focus:outline-none"
      />
    </div>
  </aside>
);

export const AdminViewHeader = ({ tab }) => {
  const t = ADMIN_TABS.find((x) => x.key === tab) || ADMIN_TABS[0];
  return (
    <div className="mb-8">
      <h1 data-testid="admin-view-title" className="font-serif text-4xl tracking-tighter text-[#EDEDED] sm:text-5xl">{t.title}</h1>
      <p className="mt-2 text-sm text-white/50">{t.sub}</p>
    </div>
  );
};

// Collapsed-by-default accordion; the wrapped panel's own header is hidden (see .rv-fold-body in index.css).
export const Fold = ({ title, icon, testid, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={testid} className="border border-white/10 bg-[#0A0A0A]">
      <button
        type="button"
        data-testid={`${testid}-toggle`}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center gap-3 px-6 py-5 text-left transition-colors duration-200 hover:bg-white/[0.03]"
      >
        {icon}
        <span className="font-serif text-xl tracking-tight text-[#EDEDED]">{title}</span>
        <CaretDown size={16} weight="bold" className={`ml-auto text-white/40 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="rv-fold-body border-t border-white/10">{children}</div>}
    </div>
  );
};
